<template>
  <div class="hubspot-form-container">
    <div
      class="hs-form-frame"
      data-region="na1"
      data-form-id="b687b3e2-548e-45f3-8a57-e389b98ba479"
      data-portal-id="20710591"
      ref="hsForm"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'HubSpotInternalFeedbackForm',
  mounted() {
    // Dynamically load the HubSpot embed script
    if (!document.getElementById('hubspot-embed-script')) {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/20710591.js';
      script.defer = true;
      script.id = 'hubspot-embed-script';
      document.body.appendChild(script);
    }
  }
};
</script>

<style lang="scss" scoped>
.hubspot-form-container {
  width: 100%;
  max-width: 600px;
  margin: 2rem auto;
  padding: 1.5rem;
  background: $color-surface;
  border-radius: $radius-lg;
  box-shadow: $shadow-sm;
}
</style>
